export type CalculateExchangeRateParams = {
  listingMarketCapitalisation: number;
  reportedMarketCapitalisation: number;
};

export type ConvertCurrencyParams = CalculateExchangeRateParams & {
  exchangeRate: number;
  fairValue: number;
};

export type ShouldConvertCurrencyParams = {
  listingCurrencyISO: string;
  reportingCurrencyISO: string;
};

export const calculateReportingToListingExchangeRate = ({
  listingMarketCapitalisation,
  reportedMarketCapitalisation,
}: CalculateExchangeRateParams): number => {
  if (listingMarketCapitalisation && reportedMarketCapitalisation) {
    return listingMarketCapitalisation / reportedMarketCapitalisation;
  }

  return 1;
};

export const calculateListingToReportingExchangeRate = ({
  listingMarketCapitalisation,
  reportedMarketCapitalisation,
}: CalculateExchangeRateParams): number => {
  if (listingMarketCapitalisation && reportedMarketCapitalisation) {
    return reportedMarketCapitalisation / listingMarketCapitalisation;
  }

  return 1;
};

export const shouldConvertCurrency = ({
  listingCurrencyISO,
  reportingCurrencyISO,
}: ShouldConvertCurrencyParams): boolean => {
  return listingCurrencyISO !== reportingCurrencyISO;
};

export const shouldCalculateExchangeRate = ({
  exchangeRate,
}: {
  exchangeRate: number;
}) => {
  return exchangeRate === 1;
};
